export const setCookie = (
  name: string,
  value: string,
  neverExpire?: boolean
) => {
  const date = new Date();

  let expires = "";

  if (neverExpire) {
    date.setFullYear(date.getFullYear() + 10);
    expires = "; expires=" + date.toUTCString();
  } else {
    date.setTime(date.getTime() + 3 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie =
    name + "=" + (value || "") + expires + "; path=/; Secure; SameSite=Strict";
};

export const getCookie = (cname: string) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const deleteCookie = (name: string) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
